<template>
  <div
    class="relative flex flex-col items-center justify-center aspect-square rounded-md bg-gray-300 shadow-sm"
    :class="{ 'bg-center bg-cover bg-no-repeat cursor-pointer': loaded }"
    :style="`background-image: url(${url})`"
  >
    <div
      v-if="withDelete"
      v-show="loaded"
      class="absolute top-1 right-1"
      @click.stop
    >
      <Component
        :is="withConfirm ? ConfirmDelete : 'div'"
        class="hover:cursor-pointer"
        :title="t('components.details.images.delete.confirm.title')"
        :description="t('components.details.images.delete.confirm.description')"
        @confirm="$emit('delete')"
        @click="!withConfirm && $emit('delete')"
      >
        <DeleteButton />
      </Component>
    </div>
    <LoadingSpinner v-show="!loaded" class="!w-16 !h-16" />
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { LoadingSpinner } from "@/Components";
import { DeleteButton } from "@/Components/Images";
import { ConfirmDelete } from "@/Components/Dialogs";

defineEmits(["delete"]);

const props = defineProps({
  url: { type: String, required: true },
  withDelete: { type: Boolean, required: false },
  withConfirm: { type: Boolean, default: true },
});

const { t } = useI18n();
const loaded = ref(false);

onMounted(() => {
  var image = new Image();
  image.onload = function () {
    loaded.value = true;
  };
  image.src = props.url;
});
</script>
